import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';
import getConfig from '../config/app-config';
import preval from 'preval.macro';

const Footer = () => {
  const config = getConfig();
  
  return (
    <Box component="footer" sx={{ bgcolor: 'primary.main', color: 'grey.100', py: 4, mt: 8 }}>
      <Container maxWidth="lg">
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} justifyContent="space-between" alignItems={{ xs: 'flex-start', md: 'center' }}>
          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
             Associate
            </Typography>
            <Typography variant="body2" sx={{ maxWidth: 480 }}>
              Associate è la piattaforma digitale per la gestione di associazioni culturali e sportive. Permette di gestire soci, corsi, eventi, pagamenti e comunicazioni in modo semplice e sicuro.
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Contatti</Typography>
            <Typography variant="body2">Email: {config.CONTACT_EMAIL}</Typography>
            <Typography variant="body2">Telefono: {config.CONTACT_PHONE}</Typography>
          </Box>
          {/* <Box>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Link utili</Typography>
            <Link href="/" color="inherit" underline="hover">Home</Link><br/>
            <Link href="/register" color="inherit" underline="hover">Registrati</Link><br/>
            <Link href="/login" color="inherit" underline="hover">Accedi</Link>
          </Box> */}
        </Stack>
        <Box sx={{ borderTop: '1px solid #444', mt: 4, pt: 2, textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography variant="caption" color="grey.400">
            © {new Date().getFullYear()} {config.BRAND_NAME}. Tutti i diritti riservati. Powered by Infinity Mundi
            
          </Typography>
          <Typography variant="caption" color="grey.400" fontSize="10px">
            {preval`module.exports = new Date().toLocaleString();`}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 